import { observable, computed, decorate } from 'mobx';
import _ from 'lodash';
import { checkRights, clearEmptyParams, formatDate, getRubs } from '../functions';
import { WorkDays } from '../shared/WorkDaysModel';



export class ProviderState {
	constructor() {
		this.Filter = { Active : true };
		this.Providers = [];
		this.Cities = [];
		this.Products = [];

		this.IsSendRequest = false;
		this.setProvider();
	}

	/** Проверка прав пользователя */
	get CanManage () { return checkRights("ManageProviders"); }
	get CanManageFinance () { return checkRights("ManageProvidersFinance") || checkRights("ManageProviders"); }

	/** Формирование столбцов в таблице */
	get columns () {
		return {
			Name : {},
			City : { width : 100, filterable : false },
			Description : { width: 250, filterable : false },
			Products : { Header : "Сырье" },
			...(this.CanManage ? { Edit : {}, Remove : {} } : { View : {} })
		};
	}

	/**
	 * Разбор ответа от сервера со списком поставщиков
	 * @param {object} data ответ от сервера
	 */
	setProviders(data) {
		this.Providers = data.Success ? data.Providers : [];
		this.IsSendRequest = true;
	}

	/**
	 * Разбор ответа от сервера с активным поставщиком
	 * @param {object} data ответ от сервера
	 */
	setProvider(data) {
		if (!_.isUndefined(data) && (data.Success || data.Id === -1))
			this.Provider = new Provider(data, this.CanManage, this.CanManageFinance);
		else this.Provider = undefined;
	}
}

decorate(ProviderState, {
	IsSendRequest: observable,
	Filter: observable,

	Providers: observable,
	Cities: observable,
	Products: observable,
	Provider: observable,
});
export class Provider {
	constructor (item, canManage, canManageFinance) {
		this.CanManage = canManage;
		this.CanManageFinance = canManageFinance;
		this.Id = item && item.Id ? item.Id : -1;
		this.Name = item && item.Name ? item.Name : "";
		this.Active = item && !_.isUndefined(item.Active) ? item.Active : true;
		this.CityId = item && item.CityId ? item.CityId : -1;
		this.Description = item && item.Description ? item.Description : "";
		this.INN = item && item.INN ? item.INN : "";
		this.KPP = item && item.KPP ? item.KPP : "";
		this.BIK = item && item.BIK ? item.BIK : "";
		this.Bank = item && item.Bank ? item.Bank : "";
		this.CorrAccount = item && item.CorrAccount ? item.CorrAccount : "";
		this.CheckAccount = item && item.CheckAccount ? item.CheckAccount : "";
		this.Address = item && item.Address ? item.Address : "";
		this.FactAddress = item && item.FactAddress ? item.FactAddress : "";
		this.DefermentPayment = item && item.DefermentPayment ? item.DefermentPayment : "";
		this.MinAmount = item && item.MinAmount && item.MinAmount !== "" ? getRubs(item.MinAmount) : "";

		this.History = undefined;

		this.Contacts = new ProviderContacts(item && item.Contacts);
		this.Products = new ProviderProducts(item && item.Products);
		this.WorkHours = new WorkDays(item && item.WorkHours);

		this.ErrorCode = "";
		this.ButtonLoading = false;
		this.SuccessSave = false;

	}

	/**
	 * Установка истории закупок поставщика при наличии данных
	 * @param {object} data ответ от сервера
	 */
	setHistory (data) {
		this.History = data && data.Success && !_.isEmpty(data.Orders)
			? new ProviderHistory(data.Orders)
			: undefined;
	}

	/**
	 * Сбор данных с формы
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 */
	collect(id, value) { this[id] = value; }

	/**
	 * Разбор ответа от сервера с реквизитами ЮЛ
	 * @param {object} value ответ от сервера dadata
	 */
	setSuggestProvider = (value) => {
		var data = value.data;
		this.Address = data.address ? data.address.value : this.Address;
		this.INN = data.inn ? data.inn : "";
		this.KPP = data.kpp ? data.kpp : "";
		this.Name = data.name ? data.name.short_with_opf : this.Name;
	}

	/**
	 * Разбор ответа от сервера с реквизитами банка
	 * @param {object} value ответ от сервера dadata
	 */
	setSuggestBank = (value) => {
		var data = value.data;
		this.BIK = data.bic ? data.bic : "";
		this.Bank = data.name ? data.name.payment : "";
		this.CorrAccount = data.correspondent_account;
	}

	/**
	 * Проверка корректности заполнения поставщика:
	 * - указано название поставщика;
	 * - выбран город;
	 * - указан юридический адрес;
	 * - у каждого контакта указано имя;
	 * - у каждого контакта заполнен телефон или E-mail;
	 * - заполненный телефон содержит не менее 10 цифр;
	 * - в каждой строке продукции выбран товар.
	 * @returns {boolean} результат проверки
	 */
	validate() {
		if (this.Name === "") {
			this.ErrorCode = "WRONG_PARAMS_NAME";
			return false;
		}

		if (this.CityId === -1 || this.CityId === "") {
			this.ErrorCode = "WRONG_PARAMS_CITY";
			return false;
		}

		if (this.Address === "") {
			this.ErrorCode = "WRONG_PARAMS_ADDRESS";
			return false;
		}

		const invalidContact = _.find(this.Contacts.List, (item) => {
			if (item.FIO === "") {
				this.ErrorCode = "WRONG_PARAMS_CONTACT_NAME";
				return true;
			}

			if (item.Phone.replace(/\D/gi, "") === "" && item.Email === "") {
				this.ErrorCode = "EMPTY_CONTACTS";
				return true;
			}

			if (item.Phone.replace(/\D/gi, "") !== "" &&  item.Phone.replace(/\D/gi, "").length < 10) {
				this.ErrorCode = "WRONG_PHONE_LENGTH";
				return true;
			}

			return false;
		});
		if (invalidContact) return false;

		if (_.some(this.Products.List, (item) => item.ProductId === -1 || item.ProductId === "")) {
			this.ErrorCode = "WRONG_PARAMS_PROVIDER_PRODUCT";
			return false;
		}

		return true;
	}

	getData() {
		var data = {
			Id : this.Id,
			Name : this.Name,
			Active : this.Active,
			CityId : this.CityId,
			Description : this.Description,
			INN : this.INN.replace(/\D/g, ""),
			KPP : this.KPP.replace(/\D/g, ""),
			BIK : this.BIK.replace(/\D/g, ""),
			Bank : this.Bank,
			CorrAccount : this.CorrAccount.replace(/\D/g, ""),
			CheckAccount : this.CheckAccount.replace(/\D/g, ""),
			Address : this.Address,
			FactAddress : this.FactAddress,
			DefermentPayment : this.DefermentPayment,
			MinAmount :  this.MinAmount*100
		}

		data = clearEmptyParams(data, [""]);

		_.each(this.Contacts.getData(), (contact, i) => {
			var name = "Contacts." + i + ".";
			_.each(contact, (value, id) => { data[name + id] = value; })
		});

		_.each(this.Products.getData(), (product, i) => {
			var name = "Products." + i + ".";
			_.each(product, (value, id) => { data[name + id] = value; });
		});

		_.each(this.WorkHours.getData(), (day, i) => {
			var name = "WorkHours." + i + ".";
			_.each(day, (value, id) => { data[name + id] = value; });
		});

		return data;
	}
}
decorate(Provider, {
	Name: observable,
	CityId: observable,
	Description: observable,
	INN: observable,
	KPP: observable,
	BIK: observable,
	Bank: observable,
	CorrAccount: observable,
	CheckAccount: observable,
	Address: observable,
	FactAddress: observable,
	DefermentPayment: observable,
	MinAmount: observable,
	History: observable,

	Products: observable,
	WorkHours: observable,
	Contacts: observable,

	ErrorCode: observable,
	ButtonLoading: observable,
	SuccessSave: observable,
})

export class ProviderContacts {
	constructor (items) {
		this.List = _.isEmpty(items) ? [new ContactInfo()] : _.map(items, (item) => new ContactInfo(item));
	}

	/** Добавить контакт */
	addItem = () => { this.List.push(new ContactInfo()); }

	/**
	 * Удалить контакт
	 * @param {number} index порядковый номер контакта
	 */
	removeItem = (index) => { this.List = _.filter(this.List, (item, itemIndex) => itemIndex !== index); }

	/** @returns {object[]} Заполненные контакты поставщика */
	getData () { return _.compact(_.map(this.List, (item) => item.getData())); }
}

decorate(ProviderContacts, {
	List: observable
});

export class ContactInfo {
	constructor(item) {
		this.Id = item && item.Id ? item.Id : -1;
		this.FIO = item && item.FIO ? item.FIO : "";
		this.Phone = item && item.Phone ? item.Phone : "";
		this.Email = item && item.Email ? item.Email : "";
	}

	/**
	 * Сбор данных с формы
	 * @param {string} id название поля
	 * @param {string} value значение поля
	 */
	collect (id, value) { this[id] = value; }

	/** @returns {object|null} Данные контакта поставщика */
	getData () {
		if (this.FIO === "") return null;

		return {
			FIO : this.FIO,
			Phone : this.Phone.replace(/\D/gi, ""),
			Email : this.Email
		};
	}
}
decorate(ContactInfo, {
	FIO: observable,
	Phone: observable,
	Email: observable
})



export class ProviderProducts {
	constructor (items) {
		this.List = _.isEmpty(items) ? [new ProductInfo()] : _.map(items, (item) => new ProductInfo(item));
	}

	/** Добавить товар */
	addItem = () => { this.List.push(new ProductInfo()); }

	/**
	 * Удалить товар
	 * @param {number} index порядковый номер товара
	 */
	removeItem = (index) => { this.List = _.filter(this.List, (item, itemIndex) => itemIndex !== index); }

	getData () {
		return _.compact(_.map(this.List, (item) => { return item.getData(); }));
	}
}

decorate(ProviderProducts, {
	List: observable
});

export class ProductInfo {
	constructor(item) {
		this.Id = item && !_.isUndefined(item.Id) ? item.Id : -1;
		this.ProductId = item && !_.isUndefined(item.ProductId) ? item.ProductId : -1;
		this.MinCount = item && item.MinCount ? item.MinCount : "";
		this.VAT = item && !_.isUndefined(item.VAT) ? item.VAT : -1;
		this.Price = item && !_.isUndefined(item.Price) ? item.Price : "";
		this.Unit = item && item.UnitNet ? item.UnitNet : "";
	}

	/**
	 * Сбор данных с формы
	 * @param {string} id Название поля
	 * @param {string|number} value Значение поля
	 * @param {object} product Товар
	 */
	collect(id, value, product) {
		this[id] = value;
		if (/ProductId/.test(id)) this.Unit = product ? product.UnitNet : "";
	}

	getData() {
		if (this.ProductId === "" || this.ProductId === -1) return null;
		return {
			Id : this.Id,
			ProductId : this.ProductId,
			MinCount : this.MinCount,
			VAT : this.VAT
		}
	}
}
decorate(ProductInfo, {
	ProductId: observable,
	MinCount: observable,
	VAT: observable,
	Unit: observable
})

export class ProviderHistory {
	constructor (items) {
		var statuses = [
			{ Id : 1, Title : "Заказано", State : "ordered"},
			{ Id : 2, Title : "Отгружено", State : "ready"},
			{ Id : 3, Title : "Оплачено", State : "success"}
		];

		this.List = _.map(items, (item) => {
			var status = _.find(statuses, { Id : item.Status });

			return {
				Amount : getRubs(item.Amount, true, true),
				Date : formatDate(item.Date),
				Status : item.Status,
				Title : status ? status.Title : "",
				State : status ? status.State : ""
			};
		});
		this.VisibleCount = 5;
		this.ShowAll = false;
	}

	/** Показать или скрыть полную историю закупок */
	toggle = () => { this.ShowAll = !this.ShowAll; }

	/** @returns {object[]} Отображаемые записи истории закупок */
	get Items () { return this.ShowAll ? this.List : _.take(this.List, this.VisibleCount); }
}

decorate(ProviderHistory, {
	List: observable,
	ShowAll: observable,
	Items: computed
});
